export enum KeySide {
  left,
  right,
  stop
}
